export default "__VITE_ASSET__DrfWsnNg__"